import {
  SESSION_TIMEOUT_MODAL_TITLE,
  buildSessionTimeoutModalMessage,
} from 'components/SessionTimeout/sessionTimeout.data';

import {
  SessionTimeoutActions,
  SessionTimeoutBackdrop,
  SessionTimeoutBody,
  SessionTimeoutContinueButton,
  SessionTimeoutLogoutButton,
  SessionTimeoutPanel,
  SessionTimeoutTitle,
} from 'styles/sessionTimeout';

type SessionTimeoutModalProps = {
  open: boolean;
  secondsRemaining: number;
  onContinueSession: () => void;
  onLogout: () => void;
  isTerminating: boolean;
};

const SessionTimeoutModal = ({
  open,
  secondsRemaining,
  onContinueSession,
  onLogout,
  isTerminating,
}: SessionTimeoutModalProps) => {
  if (!open) {
    return null;
  }

  return (
    <SessionTimeoutBackdrop role="presentation">
      <SessionTimeoutPanel role="dialog" aria-modal="true" aria-labelledby="session-timeout-title">
        <SessionTimeoutTitle id="session-timeout-title">
          {SESSION_TIMEOUT_MODAL_TITLE}
        </SessionTimeoutTitle>
        <SessionTimeoutBody>{buildSessionTimeoutModalMessage(secondsRemaining)}</SessionTimeoutBody>
        <SessionTimeoutActions>
          <SessionTimeoutContinueButton
            type="button"
            variant="tertiary"
            onClick={onContinueSession}
            disabled={isTerminating}
          >
            Continue Session
          </SessionTimeoutContinueButton>
          <SessionTimeoutLogoutButton
            type="button"
            variant="primary"
            onClick={onLogout}
            loading={isTerminating}
            loadingPreserveSize
          >
            Logout
          </SessionTimeoutLogoutButton>
        </SessionTimeoutActions>
      </SessionTimeoutPanel>
    </SessionTimeoutBackdrop>
  );
};

export default SessionTimeoutModal;
